import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { endpoints } from '../_config/endpoint';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient, private _jwt: JwtHelperService) {}

  guidLogin(payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.guidLogin}`,
      payload
    );
  }

  loggedIn() {
    const token = localStorage.getItem('token');
    return !this._jwt.isTokenExpired(token);
  }

  logout() {
    localStorage.removeItem('token');
  }
  getLoggedInUser() {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    return userDetails;
  }

  getUserType() {
    const token = localStorage.getItem('token');
    const decodedToken = this._jwt.decodeToken(token);
    return decodedToken['user_type'];
  }
}
